import { connect } from 'react-redux'

import { selectItem } from '../../../common/actions/layout'
import { fetchItemLicenses } from '../../../common/actions/searchPage'
import ItemDetails from './itemDetails'

const mapStateToProps = (state, ownProps) => {
  const { layout: { selectedItem }, searchPage: { licenses } } = state

  return {
    selected: selectedItem && selectedItem.id === ownProps.item.id,
    licenses: licenses
  }
}

const mapDispatchToProps = dispatch => {
  return {
    selectItem: item => {
      dispatch(selectItem(item))
    },
    fetchItemLicenses: itemId => {
      dispatch(fetchItemLicenses(itemId))
    }
  }
}

const ItemDetailsContainer = connect(mapStateToProps, mapDispatchToProps)(
  ItemDetails
)

export default ItemDetailsContainer
